import type { FavoritePage } from './types';

const CHANGED_EVENT = 'couplespace:favorites-changed';

let cachedFavorites: FavoritePage[] = [];
let cachedFavoriteIds = new Set<string>();

export function getFavoritePages(): FavoritePage[] {
  return cachedFavorites;
}

export function getFavoriteIds(): ReadonlySet<string> {
  return cachedFavoriteIds;
}

export function isFavoritePage(pageId: string): boolean {
  return cachedFavoriteIds.has(pageId);
}

export function setFavoriteMembership(pageId: string, favorite: boolean): void {
  const has = cachedFavoriteIds.has(pageId);
  if (favorite === has) {
    return;
  }
  const nextIds = new Set(cachedFavoriteIds);
  if (favorite) {
    nextIds.add(pageId);
  } else {
    nextIds.delete(pageId);
    cachedFavorites = cachedFavorites.filter((page) => page.id !== pageId);
  }
  cachedFavoriteIds = nextIds;
  notifyFavoritesChanged();
}

export function setFavoritePages(pages: FavoritePage[]): void {
  cachedFavorites = pages;
  cachedFavoriteIds = new Set(pages.map((page) => page.id));
  notifyFavoritesChanged();
}

export function notifyFavoritesChanged(): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new Event(CHANGED_EVENT));
}

export function subscribeFavorites(listener: () => void): () => void {
  if (typeof window === 'undefined') {
    return () => {};
  }
  window.addEventListener(CHANGED_EVENT, listener);
  return () => window.removeEventListener(CHANGED_EVENT, listener);
}
